import React from 'react';

import Profile from "./profile";
import Notifications from "components/Notifications";

function Header() {
    return (
        <nav className="main-header navbar fixed-top navbar-expand-lg navbar-light bg-white shadow-sm">
            <div className="container-fluid">
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <button className="btn p-0 ml-2 shadow-none" type="button" data-widget="pushmenu">
                            <i className="bi bi-list fs-3 text-default"/>
                        </button>
                    </li>
                </ul>
                <ul className="navbar-nav ml-auto gap-3">
                    <span className="border-left"/>
                    <Notifications />
                    <span className="border-left"/>
                    <Profile />
                </ul>
            </div>
        </nav>
    );
}

export default Header;
